import { getAppConfig } from "services/configService";
import { GET, rawPOST } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().WidgetApiUrl;
};

export const postRequestWidgetCreation = async (requestInfo, vendorId, customerEmail, albumId, productCode) => {
  //Pigeon uses vendorId, customerEmail, albumId
  //New method uses productCode This should be replaced with direct Widget API call
  var url =
    apiUrl() +
    `/Default.ashx?method=create&vendorId=${vendorId}&customeremail=${customerEmail}&albumId=${albumId}&orderCode=${productCode}`;
  const res = await rawPOST(requestInfo, url, null);

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return res.text();
  //there is a long async delay after this... you get emailed when it is ready...
};

export const getIsWidgetSupported = (requestInfo, productCode) => {
  var url = apiUrl() + `/api/v1/Order/${productCode}`;
  return GET(requestInfo, url);
};
